function getProvidersData() {
	return {
		'adt': {
			recommended: true,
			name: "Protect Your Home - ADT Authorized Premier Provider",
			slug: "adt",
			logo: require("../assets/images/adt/adt-logo.png"),
			sub_header: "Most Trusted Provider",
			tagline: "Feel secure in a name you trust",
			phone: "(844) 259-5169",
			price: "27.99",
			rank: 1,
			home_type: ["home", "apt"],
			user_type: ["own", "rent"],
			installation_type: "professional",
			features: {
				"24-7-monitoring": true,
				"no-contract": false,
				"mobile-access": true,
				"pet-friendly": true,
				"video-storage": true,
				"remote-access": true
			},	
			brief_description: "ADT is the most trusted brand in home security, and has been around for more than a century. With a focus on customer experience that includes free wireless security from Protect Your Home with any monitoring package.",
			main_features: [
				"Security experts - background checked and certified",
				"Customize a solution that is tailored for you",
				"6-month ADT Money-Back Guarantee",
				"Option to remotely arm, disarm and view video on your smartphone",
				"24/7 Customer Support"
			],
			avg_rating: "5",
			rating: {
				features: "9",
				usability: "9",
				design: "9",
				performance: "9"
			},
			benefits: [
				{
					icon: require('../assets/images/Strength-blue.png'),
					text: "TRUSTED NAME"
				},
				{
					icon: require('../assets/images/Money-blue.png'),
					text: "MONEY BACK GURANTEE"
				},
				{
					icon: require('../assets/images/Chat-blue.png'),
					text: "CUSTOMER SERVICE"
				}
			],
			banner: {
				image: require('../assets/images/adt/banner.png'),
				full_image: false
			},
			step1: {
				image: require('../assets/images/adt/step1.png')
			},
			step2: {
				image: require('../assets/images/adt/step2.png'),
				full_image: true,
				background: false,
				pros: [
					"ADT Money Back Guarantee",
					"150 installation service centers across the nation",
					"Monitoring 365 days a year",
					"Professional, custom installation"
				],
				cons: [
					"Longer contract requirement",
					"Activation fee"
				]
			},
			step3: {
				tabs: ["cord cutter", "sneak peak", "peace of mind"],
				data: {
					col1: {
						included: [true, true, true],
						list: [
							"1 wireless control panel",
							"3 wireless door/window sensors",
							"1 wireless motion detector (pet immune)",
							"1 window decal and yard sign"
						]
					},
					col2: {
						included: [false, true, true],
						list: [
							"Up to 24 hour battery backup",
							"1 key fob"
						]
					},
					col3: {
						included: [false, false, true],
						list: [
							"Installation by a certified Home Security Expert",
							"ADT’s cell guard (requires upgrade to $48.99 price point) & ability to access remotely (requires $52.99 Pulse upgrade)",
							"Video Monitoring from your mobile device (requires upgrade to Pulse)"
						]
					}
				}
			},
			step4: {
				image: require('../assets/images/adt/step2.png'),
				sub_header: "ADT is trusted name in home security that you can count on",
				steps: [
					{
						icon: "Money",
						header: "ADT MONEY-BACK GUARANTEE",
						description: "Should you decide that ADT –Monitoring Services is not for you, your installation price and all monitoring fees you paid within the first six months will be refunded."
					},
					{
						icon: "Home",
						header: "HOMEOWNER SAVINGS",
						description: "By installing an ADT-Monitored Home Security System, you may save on your homeowner’s insurance."
					},
					{
						icon: "Eye",
						header: "24HR MONITORING",
						description: "ADT’s monitoring centers provide protection with the latest technological equipment 24 hours a day, 365 days a year."
					}
				]
			},
			step5: {
				sub_header: "“9.5/10 OF CUSTOMERS RECOMMEND ADT”",
				reviews: [
					{
						header: "Very personable and professional",
						review: '“Security tech was very personable and professional. Knew what he was doing and knew how to best equip us to live in a safely protected house.”',
						author: "Rachel"
					},
					{
						header: "Your installer was excellent",
						review: '“Your installer was excellent. He even went above the call of duty by training my kids and other kids in the neighborhood on fire safety.”',
						author: "Jennifer"
					},
					{
						header: "Great customer service",
						review: '“Customer service was great and informative; the technician was informative; and polite, gave me all the information I needed for my alarm system.”',
						author: "Danial"
					}
				]
			},
			referral_link: "http://www.protectyourhome.com/partners/irelo-lp-01lt",
			special_offer: "FREE security system, an $850 value when you get ADT Monitoring today with purchase of a 36/24 month monitoring agreement and $99 installation fee!"
		},
		'frontpoint': {
			name: "Frontpoint",
			slug: "frontpoint",
			logo: require("../assets/images/frontpoint/fp-logo.png"),
			sub_header: "Best Customer Support",
			tagline: "Security that fits your needs",
			phone: "(855) 680-2457",
			price: "34.99",
			rank: 2,
			home_type: ["home", "apt"],
			user_type: ["own", "rent"],
			installation_type: "diy",
			features: {
				"24-7-monitoring": true,
				"no-contract": true,
				"mobile-access": true,
				"pet-friendly": true,
				"video-storage": true,
				"remote-access": true
			},	
			brief_description: "Frontpoint’s scalable system and monitoring services, solid performance and peel-and-stick security system make it one of the most appealing DIY security systems available today.",
			main_features: [
				"DIY installation",
				"24/7 Service",
				"Peel and stick sensors to doors and window, but also cabinets and drawers",
				"Mobile App to control your home system",
				"Option to automate lights, thermostats and door locks"
			],
			avg_rating: "5",
			rating: {
				features: "10",
				usability: "9",
				design: "7",
				performance: "8"
			},
			benefits: [
				{
					icon: require('../assets/images/Strength-blue.png'),
					text: "EASY INSTALL"
				},
				{
					icon: require('../assets/images/Money-blue.png'),
					text: "TRANSPARENT PRICING"
				},
				{
					icon: require('../assets/images/Chat-blue.png'),
					text: "CUSTOMER SERVICE"
				}
			],
			banner: {
				image: require('../assets/images/frontpoint/banner.png'),
				full_image: true
			},
			step1: {
				image: require('../assets/images/frontpoint/step1.png')
			},
			step2: {
				image: require('../assets/images/frontpoint/step2.png'),
				full_image: false,
				background: true,
				pros: [
					"30-day risk-free trial",
					"24/7 professional monitoring",
					"Mobile access",
					"Easy peel-and-stick system",
					"No hidden fees",
					"100% wireless equipment"
				],
				cons: [
					"Only 3 year equipment waranty",
					"Limited home automation",
					"Required contract"
				]
			},
			step3: {
				tabs: ["protecion", "interactive", "ultimate"],
				data: {
					col1: {
						included: [true, true, true],
						list: [
							"100% Wireless & Cellular",
							"Intrusion Protection",
							"Environmental Protection",
							"Fire Protection",
							"Life Safety",
							"24/7 Professional Service"
						]
					},
					col2: {
						included: [false, true, true],
						list: [
							"Crash & Smash Protection",
							"Email & Text Alerts",
							"Remote Access & Control",
							"Light Controls",
							"Geo Services"
						]
					},
					col3: {
						included: [false, false, true],
						list: [
							"Live Video Streaming",
							"Motion-Activated Alerts",
							"HD & Night Vision Capabilities",
							"Automated Door Locks",
							"Energy Management Control"
						]
					}
				}
			},
			step4: {
				image: require('../assets/images/frontpoint/step4.png'),
				sub_header: "One of the clear advantages of Frontpoint is its stick-and-peel components and sensors, which allow for easy installation.",
				steps: [
					{
						icon: "Chat",
						header: "CUSTOMER SERVICE",
						description: "Frontpoint has been awarded the Angie’s List Super Service Award for several years running by continuing their customer-focused approach."
					},
					{
						icon: "Eye",
						header: "MONITORING",
						description: "Provides 24/7 professional monitoring with all packages. Ability to upgrade to the Ultimate Plan, for video monitoring and remote access to a live stream of your security cameras."
					},
					{
						icon: "Home",
						header: "HOME AUTOMATION",
						description: "Offers multiple home automation devices that can integrate into your system, including lights, thermostats, door locks, and more."
					}
				]
			},
			step5: {
				sub_header: '“96% OF CUSTOMERS RECOMMEND FRONTPOINT.”',
				reviews: [
					{
						header: "No Problem at all",
						review: '“I have Frontpoint Security for at least 3 years now. No problem at all. Wireless - love it. Interactive, easy access on my iphone. Love the arming reminders.”',
						author: "Noemi H."
					},
					{
						header: "Installation was very easy",
						review: '“Installation was very easy. A quick phone call to activate the system and just placing all of the various detectors around.”',
						author: "James"
					},
					{
						header: "Easy ordering, Easy install",
						review: '“Easy ordering, easy install, easy to use, great customer service.”',
						author: "Catherine W."
					}
				]
			},
			referral_link: "http://get.frontpointsecurity.com/2070",
			special_offer: "FREE life safety with any Frontpoint plan!"
		},
		'protect-america': {
			name: "Protect America",
			slug: "protect-america",
			logo: require("../assets/images/protect-america/pa-logo.png"),
			sub_header: "Low Cost Option",
			tagline: "A secure customer choice.",
			phone: "(888) 289-8118",
			price: "19.99",
			rank: 3,
			home_type: ["home", "apt"],
			user_type: ["own", "rent"],
			installation_type: "diy",
			features: {
				"24-7-monitoring": true,
				"no-contract": true,
				"mobile-access": true,
				"pet-friendly": true,
				"video-storage": true,
				"remote-access": true
			},	
			brief_description: "Protect America’s home security equipment is centered around total home protection, with intrusion and motion detection, that’s better security.",
			main_features: [
				"24/7 monitoring",
				"No installation fees",
				"Locked-in monthly rate",
				"Price match guarantee",
				"Intelligent alerts and HD video on your smartphone"
			],
			avg_rating: "4",
			rating: {
				features: "7",
				usability: "7",
				design: "6",
				performance: "8"
			},
			benefits: [
				{
					icon: require('../assets/images/Strength-blue.png'),
					text: "DIY INSTALL"
				},
				{
					icon: require('../assets/images/Screen-blue.png'),
					text: "LIFETIME EQUIPMENT WARRANTY"
				},
				{
					icon: require('../assets/images/Chat-blue.png'),
					text: "CUSTOMER SERVICE"
				}
			],
			banner: {
				image: require('../assets/images/protect-america/banner.png'),
				full_image: false
			},
			step1: {
				image: require('../assets/images/protect-america/step1.png')
			},
			step2: {
				image: require('../assets/images/protect-america/step2.png'),
				full_image: true,
				background: true,
				pros: [
					"Free DIY Installation",
					"No upfront costs",
					"5 equipment plan choices, 3 monitoring options for most",
					"Lifetime equipment warranty"
				],
				cons: [
					"Mobile App only included in more expensive plans",
					"Home Automation only included in more expensive plans"
				]
			},
			step3: {
				tabs: ["copper", "silver", "platinium"],
				data: {
					col1: {
						included: [true, true, true],
						list: [
							"Most affordable coverage",
							"Standard control panel",
							"3 Door/window sensors",
							"1 Motion detector",
							"1 Yard sign",
							"4 Door/window stickers"
						]
					},
					col2: {
						included: [false, true, true],
						list: [
							"Most popular plan",
							"Standard control panel",
							"9 Door/window sensors"
						]
					},
					col3: {
						included: [false, false, true],
						list: [
							"14 Door/window sensors",
							"Motion-Activated Alerts"
						]
					}
				}
			},
			step4: {
				image: require('../assets/images/protect-america/step4.png'),
				sub_header: "For over 25 years, Protect America has taken pride in providing affordable home security for everyone.",
				steps: [
					{
						icon: "Screen",
						header: "FEATURES",
						description: "Option for smartphone alerts/notifications that allow you remote access and system control."
					},
					{
						icon: "Eye",						
						header: "MONITORING",
						description: "Ability to monitor for fire/smoke, carbon monoxide and water/flood wirelessly 24/7."
					},
					{
						icon: "Protected",
						header: "EQUIPMENT",
						description: "Option to include HD video cameras, garage door controllers, lighting/ thermostat control and keychain remotes to fully equip your home."
					}
				]
			},
			step5: {
				sub_header: '“WINNER OF CONSUMERS DIGEST BEST BUY FOR 8 YEARS.”',
				reviews: [
					{
						header: "Great Customer Service",
						review: "“Holy Cow, so far I'm overwhelmed with enthusiasm over your customer support installation department! I hope more good things are to come! Still in shock over the fantastic customer service!”",
						author: "Darrick"
					},
					{
						header: "Saved almost $200",
						review: "“I liked that I was able to save almost $200 by going with a system that allowed DIY install. It was super easy to set up and I didn't have any issues getting it connected.”",
						author: "Brenda H."
					},
					{
						header: "Always helpful",
						review: "“I had Protect America for about 10 yrs and they have always been helpful whenever I needed help. So far so good.”",
						author: "Richard B."
					}
				]
			},
			referral_link: "http://www.protectamerica.com/?agent=a11056&affkey=irelo",
			special_offer: "Upon sign up, save up to $1,400 in free equipment!"
		},
		'vivint': {
			name: "Vivint",
			slug: "vivint",
			logo: require("../assets/images/vivint/vivint-smarthome.png"),
			sub_header: "Top Home Automation",
			tagline: "Get state of the art security.",
			phone: "(855) 330-7566",
			price: "39.99",
			rank: 4,
			home_type: ["home", "apt"],
			user_type: ["own", "rent"],
			installation_type: "professional",
			features: {
				"24-7-monitoring": true,
				"no-contract": false,
				"mobile-access": true,
				"pet-friendly": false,
				"video-storage": true,
				"remote-access": true
			},
			brief_description: "Vivint’s home security system is built for automation with advanced technology and modern equipment. This makes it the best customizable system on the list available.",
			main_features: [
				"The #1 smart home services provider in the U.S.",
				"Rated 4.5 stars on The App Store",
				"Monthly service plans available",
				"Professional installation and $0 activation"
			],
			avg_rating: "4",
			rating: {
				features: "9",
				usability: "8",
				design: "7",
				performance: "7"
			},
			benefits: [
				{
					icon: require('../assets/images/Strength-blue.png'),
					text: "EASY INSTALL"
				},
				{
					icon: require('../assets/images/Mobile-blue.png'),
					text: "BEST MOBILE APP"
				},
				{
					icon: require('../assets/images/Screen-blue.png'),
					text: "GREAT EQUIPMENT"
				}
			],
			banner: {
				image: require('../assets/images/vivint/banner.png'),
				full_image: false
			},
			step1: {
				image: require('../assets/images/vivint/step1.png')
			},
			step2: {
				image: require('../assets/images/vivint/step2.png'),
				full_image: true,
				background: true,
				pros: [
					"Month-to-month security monitoring options",
					"Free professional installation",
					"Best home automation integration",
					"Mobile-app with the highest ratings"
				],
				cons: [
					"More upfront costs for equipment",
					"Contract requirements are longer"
				]
			},
			step3: {
				tabs: ["equipment options"],
				data: {
					col1: {
						included: [true],
						list: [
							"Door and window sensors",
							"Indoor cameras",
							"Recessed door sensors",
							"Thermostats",
							"1 Yard sign",
							"Motion sensors"
						]
					},
					col2: {
						included: [true],
						list: [
							"Glass break detectors",
							"Key fobs",
							"Medical pendants",
							"Carbon monoxide detectors"
						]
					},
					col3: {
						included: [true],
						list: [
							"Temperature/flood sensors",
							"Lamp modules",
							"Smoke detectors"
						]
					}
				}
			},
			step4: {
				image: require('../assets/images/vivint/step4.png'),
				sub_header: "With a superior mobile app, financing for equipment costs, options for month-to-month contracts, Vivint wants to ensure you'll be safe and satisfied customer.",
				steps: [
					{
						icon: "Chat",
						header: "CUSTOMER SERVICE",
						description: "Customers have continued to be impressed with the superior service they receive form Vivint support reps and in home installation experts."
					},
					{
						icon: "Eye",
						header: "MONITORING",
						description: "Vivint has the highest rated monitoring app on the market. Package options include live streaming and video monitoring for 24/7 peace of mind."
					},
					{
						icon: "Home",
						header: "HOME AUTOMATION",
						description: "Not only does Vivint have the largest range of equipment options to manage your home it also integrates with Amazon echo and Nest thermostats."
					}
				]
			},
			step5: {
				sub_header: '“4.5/5 RATED SMART PHONE APP.”',
				reviews: [
					{
						header: "Very happy with Vivint",
						review: "“I’m very happy with Vivint. They are very responsive and are easy to work with. Their staff is very professional and really listen to their customers.”",
						author: "Hillary M."
					},
					{
						header: "Totally in love",
						review: "“I’ve been using my Vivint system for about a year and a half now. I’ve totally fallen in love with the smart home parts of it.”",
						author: "Josh G."
					},
					{
						header: "Referred to friends",
						review: "“We love our new Vivint system. We have referred several of our friends to you. We are so glad we switched from the traditional alarm system.”",
						author: "Alvin S."
					}
				]
			},
			referral_link: "http://vivtrk.com/?a=8&c=114&s1=",
			special_offer: "FREE installation, and $0 activation with sign up!"
		}
	}
}

export { getProvidersData }


// WEBPACK FOOTER //
// ./src/helpers/data-helper.js